import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'

import ProductList from '../shared/ProductList';
import MoloRingloader from '../layout/MoloRingloader';
// import Style from '../../models/Style';
import Style, { createStyle } from 'molo-shared/lib/models/Style';

// Store.
import { RootState } from '../../store';
import { IUserSate } from '../../store/user/reducers';
import { getCollectionMasters } from '../../store/collections/actions';
import { ICollectionState } from '../../store/collections/reducers';
import { IFilterState } from '../../store/session/reducers';
import { Filter } from '../../models/Filter';
import { resetFilter } from '../../store/session/actions';

interface State {
    products: Style[],
    loading: boolean,
}
  
interface OwnProps {
    match: {params: {collection: string, orderType: string}},
}
  
interface DispatchProps {
    getCollectionMasters: (orderType: string, collectionName: string, currencyCode: string, pricegroup: string) => void;
    resetFilter: (filter: Filter) => void
}
  
interface StateProps {
    userState: IUserSate,
    collectionState: ICollectionState,
    isFetchingCollectionMasters: boolean
    filterState: IFilterState
}
  
type Props = StateProps & OwnProps & DispatchProps;

export class ProductListContainer extends Component<Props, State> {

    state = { products: [], loading: true }

    componentDidMount() {
        this.fetchIfReady();
    }

    componentDidUpdate(prevProps: Props) {
        const prev = prevProps.match && prevProps.match.params;
        const cur = this.props.match && this.props.match.params;
        const prevCollection = prev && prev.collection !== undefined && prev.collection !== null ? String(prev.collection) : '';
        const prevOrderType = prev && prev.orderType !== undefined && prev.orderType !== null ? String(prev.orderType) : '';
        const collectionName = cur && cur.collection !== undefined && cur.collection !== null ? String(cur.collection) : '';
        const orderType = cur && cur.orderType !== undefined && cur.orderType !== null ? String(cur.orderType) : '';

        if (
            (prevCollection !== collectionName || prevOrderType !== orderType) &&
            !this.props.isFetchingCollectionMasters
        ) {
            this.fetchCollection(orderType, collectionName);
        }
    }

    componentWillUnmount = () => {
        console.log('unmount :: ProductListContainer')
    }

    public static getDerivedStateFromProps(props: Props, state: State) {
        
        if (props.collectionState.styles && props.collectionState.styles.length) {
          return {
              loading: false,
              products: props.collectionState.styles
          }
        }
        return null;
    }

    fetchIfReady = () => {
        const p = this.props.match && this.props.match.params;
        if (!p || !this.props.userState.user) {
            return;
        }
        const collectionName = p.collection !== undefined && p.collection !== null ? String(p.collection) : '';
        const orderType = p.orderType !== undefined && p.orderType !== null ? String(p.orderType) : '';
        if (!collectionName || !orderType) {
            return;
        }
        if (!this.props.isFetchingCollectionMasters) {
            const hasCachedStyles =
                !!this.props.collectionState.styles &&
                this.props.collectionState.styles.length > 0;
            this.fetchCollection(orderType, collectionName, { skipResetFilter: hasCachedStyles });
        }
    }

    fetchCollection = (
        orderType: string,
        collectionName: string,
        options?: { skipResetFilter?: boolean }
    ) => {
        const currencyCode = this.props.userState.user.currencyCode;
        const pricegroup = this.props.userState.user.customerData.pricegroup;
        this.props.getCollectionMasters(orderType, collectionName, currencyCode, pricegroup);
        if (this.props.filterState.filter && !(options && options.skipResetFilter)) {
            this.props.resetFilter(this.props.filterState.filter);
        }
    }

    render() {
        const { products, loading } = this.state;

        return (
            <div>
                {(loading || this.props.isFetchingCollectionMasters) && <div style={{height: '100vh', width: '100vw', position:'fixed'}}><MoloRingloader /></div>}
                {
                    (!loading && !this.props.isFetchingCollectionMasters) &&
                    <ProductList
                        products={products}
                        lineDiscount={this.props.userState.user.customerData.linediscount}
                        useInfiniteScroll={true}
                        showAgeSegmentQuickFilter={true}
                    />
                }
            </div>
        )
    }
}

const mapStateToProps = (states: RootState, ownProps: OwnProps): StateProps => {
    return {
        userState: states.user.user,
        collectionState: states.collections.collections,
        isFetchingCollectionMasters: states.collections.collections.isFetchingCollectionMasters,
        filterState: states.session.filter,
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>, ownProps: OwnProps): DispatchProps => {
    return {
        getCollectionMasters: async (orderType: string, collectionName: string, currencyCode: string, pricegroup: string) => {
            await dispatch(getCollectionMasters(orderType, collectionName, currencyCode, pricegroup));
        },
        resetFilter: async (filter: Filter) => {
            await dispatch(resetFilter(filter))
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ProductListContainer)